if (window.lorry && Array.isArray(window.lorry.quotes)) {
  const randomIndex = Math.floor(Math.random() * window.lorry.quotes.length);
  if (randomIndex > 0) {
    const quote = window.lorry.quotes[randomIndex];
    const heroTitle = document.querySelector('#fpHeroTitle');
    const heroLead = document.querySelector('#fpHeroLead');

    if (heroTitle && heroLead) {
      heroTitle.innerText = quote.text;
      heroLead.innerText = quote.source;
    }
  }
}
